import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Error handler
export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Create axios instance with defaults
const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Auth API
export const authAPI = {
  register: async (email, password, name) => {
    const { data } = await api.post('/auth/register', { email, password, name });
    return data;
  },

  login: async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    return data;
  },

  logout: async () => {
    const { data } = await api.post('/auth/logout');
    return data;
  },

  getMe: async () => {
    const { data } = await api.get('/auth/me');
    return data;
  },
};

// Products API
export const productsAPI = {
  getAll: async (category = null, featured = null) => {
    const params = {};
    if (category) params.category = category;
    if (featured !== null) params.featured = featured;
    const { data } = await api.get('/products', { params });
    return data;
  },

  getById: async (id) => {
    const { data } = await api.get(`/products/${id}`);
    return data;
  },

  create: async (product) => {
    const { data } = await api.post('/products', product);
    return data;
  },

  update: async (id, updates) => {
    const { data } = await api.put(`/products/${id}`, updates);
    return data;
  },

  delete: async (id) => {
    const { data } = await api.delete(`/products/${id}`);
    return data;
  },
};

// Cart API
export const cartAPI = {
  get: async () => {
    const { data } = await api.get('/cart');
    return data;
  },

  add: async (product_id, selectedSize, quantity) => {
    const { data } = await api.post('/cart/add', { product_id, selectedSize, quantity });
    return data;
  },

  update: async (item_id, quantity) => {
    const { data } = await api.put(`/cart/update/${item_id}`, null, { params: { quantity } });
    return data;
  },

  remove: async (item_id) => {
    const { data} = await api.delete(`/cart/remove/${item_id}`);
    return data;
  },

  clear: async () => {
    const { data } = await api.delete('/cart/clear');
    return data;
  },
};

// Orders API
export const ordersAPI = {
  create: async (items, shipping_info) => {
    const { data } = await api.post('/orders', { items, shipping_info });
    return data;
  },

  getUserOrders: async () => {
    const { data } = await api.get('/orders');
    return data;
  },

  getById: async (id) => {
    const { data } = await api.get(`/orders/${id}`);
    return data;
  },
};

// Admin API
export const adminAPI = {
  getAllOrders: async () => {
    const { data } = await api.get('/admin/orders');
    return data;
  },

  updateOrderStatus: async (order_id, status) => {
    const { data } = await api.put(`/admin/orders/${order_id}/status`, null, { params: { status } });
    return data;
  },
};

export default api;
